import { post } from '../utility';

export const search = ({ callback }) => {
	post({
		method: 'systemMigrations.search',
		params: {},
		callback,
	});
};

export const runPending = ({ callback }) => {
	post({
		method: 'systemMigrations.runPending',
		params: {},
		callback,
	});
};

export const rerun = ({ migrationName, callback }) => {
	post({
		method: 'systemMigrations.rerun',
		params: { migrationName },
		callback,
	});
};

export const setAutoRun = ({ enabled, callback }) => {
	post({
		method: 'systemMigrations.setAutoRun',
		params: { enabled },
		callback,
	});
};
